<template>
    <div @click="clickUpload">
        <slot></slot>
        <input type="file" :accept="accept" :id="id" style="display: none;" @change="showFiles">
    </div>
</template>

<script>
    /**
     * ComponentName: 选择文件
     * Created Date:2021/9/4
     * Author: pyh
     * Modifier: dhg
     * 组件说明：
     * 传值：
     *     属性名   类型      说明
     *     accept  String    选择文件类型
     *     ruleFn  Function  选择文件前校验函数，默认没有，如果有会先执行
     *  api:
     *     方法名  参数
     *     change 选择的文件
     *  eg:
     *  <vi-upload accept="image/png,image/jpeg" @change="showFile" :ruleFn="fun">
            <span>上传</span>
        </vi-upload>
     *
     */
    const ObjectID = require("bson-objectid");
    export default {
        name: 'cl-select-file',
        props: {
            accept: {
                type: String,
                default: ''
            },
            ruleFn: Function
        },
        data() {
            return {
                id: ObjectID().toHexString()
            }
        },
        mounted() {
            let el = document.getElementById(this.id);
            el.onclick = ev => {
                let event = ev || window.event;
                if (event.stopPropagation) { //
                    event.stopPropagation();
                } else {
                    event.cancelBubble = true; //IE阻止事件冒泡
                }
            }
        },
        methods: {
            // 选择文件
            clickUpload() {
                let fn = () => {
                    let el = document.getElementById(this.id);
                    el.value = '';
                    el.click();
                }
                if (this.ruleFn) {
                    this.ruleFn().then(msg => {
                        if (msg) { // 提示点击确定
                            fn();
                        }
                    })
                } else {
                    fn();
                }
            },
            showFiles() {
                let file = document.getElementById(this.id).files[0];
                // console.log(file,'file');
                var blob = new Blob([file]), // 文件转化成二进制文件
                    url = URL.createObjectURL(blob); //转化成url
                // console.log(url,'url');
                let ext = file.name.split('.')[1];
                if (['PNG', 'JPG', 'JPEG'].includes(ext.toUpperCase())) {
                    this.$utils.path2base64(file).then(path => {
                        this.$emit('change', path);
                    }).catch(err => {
                        console.log('error', err);
                    })
                } else {
                    this.$emit('change', file);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>